import { render } from "./querySelectedLernpfad.vue?vue&type=template&id=2d23a580"
import script from "./querySelectedLernpfad.vue?vue&type=script&lang=js"
export * from "./querySelectedLernpfad.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__